<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:body>
        <b-row>
          <!-- View Only -->
          <b-col v-if="editAttendanceDetails" sm="12" md="12" lg="12">
            <b-table-simple striped bordered small hover>
              <tbody>
                <b-tr>
                  <b-td>{{ $t('globalTrans.organization') }}</b-td>
                  <b-td colspan="3">{{ (currentLocale === 'en') ? editAttendanceDetails.org_name : editAttendanceDetails.org_name_bn }}</b-td>
                </b-tr>
                <b-tr>
                  <b-td>{{ $t('child_configuration.institute_type') }}</b-td>
                  <b-td colspan="3">{{ getInstituteTypeName(editAttendanceDetails.office_type_id) }}</b-td>
                </b-tr>
                <b-tr>
                  <b-td>{{ $t('child_configuration.institute_name') }}</b-td>
                  <b-td colspan="3">{{ (currentLocale === 'en') ? editAttendanceDetails.institute_name : editAttendanceDetails.institute_name_bn }}</b-td>
                </b-tr>
                <b-tr>
                  <b-td>{{ $t('educational_management.class') }}</b-td>
                  <b-td colspan="3">{{ (currentLocale === 'en') ? editAttendanceDetails.class_name : editAttendanceDetails.class_name_bn }}</b-td>
                </b-tr>
                <b-tr>
                  <b-td>{{ $t('institute_manangement.attendance_date') }}</b-td>
                  <b-td colspan="3">{{ editAttendanceDetails.attendance_date | dateFormat }}</b-td>
                </b-tr>
              </tbody>
            </b-table-simple>
          </b-col>

          <!-- Form -->
          <b-col sm="12" md="12" lg="12">
            <b-overlay :show="detailsLoader">
              <b-row>
                <b-col xl="12" lg="12" sm="12">
                  <b-table-simple bordered>
                    <thead class="text-white bg-primary">
                        <tr>
                          <th class="text-center" width="100px">{{ $t('globalTrans.sl_no') }}</th>
                          <th scope="col">{{ $t('educational_management.student_name') }}</th>
                          <th scope="col">{{ $t('admission_management.student_roll') }}</th>
                        </tr>
                    </thead>
                    <b-tbody>
                        <b-tr v-for="(item, index) in attendance.list" :key="index">
                            <b-td class="text-center">{{ $n(index + 1) }}</b-td>
                            <b-td>{{ (currentLocale === 'en') ? item.text_en : item.text_bn }}</b-td>
                            <b-td>{{ $n(item.student_id, { useGrouping: false }) }}</b-td>
                        </b-tr>
                        <b-tr v-if="attendance.list.length === 0">
                            <td colspan="5" class="text-center">
                              <span class="text-black">{{ $t('globalTrans.noDataFound') }}</span>
                            </td>
                        </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </b-col>
              </b-row>

            </b-overlay>
          </b-col>
        </b-row>
      </template>
    </iq-card>
  </b-container>
</template>
<script>

import RestApi, { disabilitySchoolServiceBaseUrl } from '@/config/api_config'
import { classAttendanceStudentAttendanceInfoApi } from '../../api/routes'

export default {
  props: ['id'],
  components: {},
  created () {
    if (this.id) {
      const attendance = this.getDataFromStore()
      if (!attendance) return
      /** In Edit Mode */
      this.inEditMode = true
      this.editAttendanceDetails = attendance

      this.search.org_id = attendance.org_id
      this.search.office_type_id = attendance.office_type_id
      this.search.office_id = attendance.office_id
      this.search.class_id = attendance.class_id
      this.attendance.attendance_date = attendance.attendance_date

      this.searchData()
    }
  },
  mounted () {
  },
  data () {
    return {
      saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
      search: {
        fiscal_year_id: 0,
        org_id: 0,
        office_type_id: 0,
        office_id: 0,
        class_id: 0
      },
      attendance: {
        attendance_date: '',
        list: []
      },
      inEditMode: false,
      editAttendanceDetails: null,
      detailsLoader: false
    }
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    }
  },
  watch: {
  },
  methods: {
    getDataFromStore () {
      const tmpData = this.$store.state.list.find(item => item.id === this.id)
      return tmpData !== undefined ? JSON.parse(JSON.stringify(tmpData)) : null
    },
    getInstituteTypeName (id) {
      const tmpData = this.$store.state.commonObj.officeTypeList.find(item => item.value === id)
      if (this.$i18n.locale === 'bn') {
        return tmpData.text_bn
      } else {
         return tmpData.text_en
      }
    },
    getRelationalData (data) {
      if (this.inEditMode && this.id) {
        return data.filter(item => {
          if (item.class_attendance_id) {
            return item
          }
        })
      }
    },
    /**
     * Asynchronous
     */
    async searchData () {
      this.detailsLoader = true
      let result = null

      /** Search */
      if (this.inEditMode && this.id) {
        result = await RestApi.getData(
          disabilitySchoolServiceBaseUrl,
          classAttendanceStudentAttendanceInfoApi,
          { attendance_date: this.attendance.attendance_date, ...this.search }
        )
      }

      if (result.success && result.data) {
        this.attendance.list = this.getRelationalData(result.data)
      } else {
        this.attendance.list = []
      }

      this.detailsLoader = false
    }
    /** EMD */
  }
}
</script>
